import { render } from "./PermissionsTabMenu.vue?vue&type=template&id=7b776e29&scoped=true"
import script from "./PermissionsTabMenu.vue?vue&type=script&lang=js"
export * from "./PermissionsTabMenu.vue?vue&type=script&lang=js"

import "./PermissionsTabMenu.vue?vue&type=style&index=0&id=7b776e29&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b776e29"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QInnerLoading});
